/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useQuery, useLazyQuery } from "@apollo/client";
import { Box } from "@material-ui/core";

import { GET_COURSES } from "graphql/query/admin";
import Table from "Components/Table/Table";
import { formStyles } from "../listStyles";

const Courses = ({
  setErrorMsg,
  searchQuery,
  actionPerformed,
  setActionPerformed,
  handleEditCourse,
}) => {
  const navigate = useNavigate();
  const classes = formStyles();
  const [courses, setCourses] = useState([]);
  const [pageInfo, setPageInfo] = useState("");
  const [page, setPage] = useState(0);

  const buildFilters = () => ({
    ...(searchQuery?.length > 0 && { name: searchQuery }),
  });

  const { data, refetch, error, loading } = useQuery(GET_COURSES, {
    variables: {
      first: 10,
      orderBy: "createdAt_DESC",
      filters: buildFilters(),
    },
    fetchPolicy: "network-only",
  });

  const [getNextPage, { loading: nextPageLoader }] = useLazyQuery(GET_COURSES);
  const [getPrevPage, { loading: prevPageLoader }] = useLazyQuery(GET_COURSES);

  const mapList = (edges) => edges.map((c) => ({
    ...c.node,
    statusLabel: c.node.isActive ? "Active" : "Inactive",
  }));

  const handleNextPage = async () => {
    if (pageInfo.hasNextPage) {
      const nextPageData = await getNextPage({
        variables: {
          first: 10,
          after: pageInfo.endCursor,
          orderBy: "createdAt_DESC",
          filters: buildFilters(),
        },
        fetchPolicy: "network-only",
      });
      if (nextPageData.data.courses) {
        setCourses(mapList(nextPageData.data.courses.edges));
        setPage(page + 1);
        setPageInfo(nextPageData.data.courses.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const handlePreviousPage = async () => {
    if (pageInfo.hasPreviousPage) {
      const prevPageData = await getPrevPage({
        variables: {
          last: 10,
          before: pageInfo.startCursor,
          orderBy: "createdAt_DESC",
          filters: buildFilters(),
        },
        fetchPolicy: "network-only",
      });
      if (prevPageData.data.courses) {
        setCourses(mapList(prevPageData.data.courses.edges));
        setPage(page - 1);
        setPageInfo(prevPageData.data.courses.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const setAllCourses = () => {
    if (data && data.courses) {
      setPageInfo(data.courses.pageInfo);
      setCourses(mapList(data.courses.edges));
      setErrorMsg("");
    }
    setPage(0);
  };

  useEffect(() => {
    if (actionPerformed) {
      refetch();
      setActionPerformed(false);
    }
    if (error) {
      setErrorMsg("Error in loading data !");
    }
    setAllCourses();
  }, [data, actionPerformed, error, searchQuery]);

  const handleViewButton = (course) => {
    navigate("/admin/course/view-course", { state: { id: course.id } });
  };

  const handleEditButton = (course) => {
    handleEditCourse(course);
  };

  const TABLE_HEAD = [
    { id: "id", flag: "id", label: "No.", alignRight: false },
    { id: "name", flag: "name", label: "Name", alignRight: false },
    { id: "type", flag: "type", label: "Type", alignRight: false },
    { id: "tag", flag: "tag", label: "Tag", alignRight: false },
    { id: "price", flag: "price", label: "Price", alignRight: false },
    { id: "statusLabel", flag: "statusLabel", label: "Status", alignRight: false },
    { id: "createdAt", flag: "createdAt", label: "Created At", alignRight: false },
    {
      id: "actions",
      flag: { read: true, edit: true },
      alt: "data",
      callback: { handleViewButton, handleEditButton },
      label: "Actions",
      alignRight: false,
    },
  ];

  return (
    <Box className={classes.mainContainer}>
      <Table
        error={error}
        USERLIST={courses}
        page={page}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        TABLE_HEAD={TABLE_HEAD}
        pageInfo={pageInfo}
        loading={loading || nextPageLoader || prevPageLoader}
      />
    </Box>
  );
};

export default Courses;
